<template>
  <div class="relative w-full aspect-square max-w-md mx-auto mb-8">
    <img 
      src="https://firebasestorage.googleapis.com/v0/b/aline-perim-prod.appspot.com/o/images%2Fquiz%2Fpeople-circle.avif?alt=media&token=ecda6127-47e1-4d14-87ad-ef30dc2a8db0"
      alt="People Circle"
      class="w-full h-full object-contain"
    />
  </div>
</template>